import { Size } from '../enums/size.enum';

export type BST01WaistSize =
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32
  | 33
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50;

export type BST01BraSize =
  | '30A'
  | '30B'
  | '30C'
  | '30D'
  | '30DD/E'
  | '30DDD/F'
  | '30G'
  | '32A'
  | '32B'
  | '32C'
  | '32D'
  | '32DD/E'
  | '32DDD/F'
  | '32G'
  | '34A'
  | '34B'
  | '34C'
  | '34D'
  | '34DD/E'
  | '34DDD/F'
  | '34G'
  | '36A'
  | '36B'
  | '36C'
  | '36D'
  | '36DD/E'
  | '36DDD/F'
  | '36G'
  | '38A'
  | '38B'
  | '38C'
  | '38D'
  | '38DD/E'
  | '38DDD/F'
  | '38G'
  | '40A'
  | '40B'
  | '40C'
  | '40D'
  | '40DD/E'
  | '40DDD/F'
  | '40G'
  | '42A'
  | '42B'
  | '42C'
  | '42D'
  | '42DD/E'
  | '42DDD/F'
  | '42G'
  | '44A'
  | '44B'
  | '44C'
  | '44D'
  | '44DD/E'
  | '44DDD/F'
  | '46A'
  | '46B'
  | '46C'
  | '46D'
  | '46DD/E'
  | '48A'
  | '48B'
  | '48C'
  | '48D'
  | '48DD/E';

const bst01WaistToSize: { [waist in BST01WaistSize]: Size } = {
  23: Size.XS,
  24: Size.XS,
  25: Size.S,
  26: Size.S,
  27: Size.S,
  28: Size.S,
  29: Size.S,
  30: Size.M,
  31: Size.M,
  32: Size.M,
  33: Size.L,
  34: Size.L,
  35: Size.L,
  36: Size.XL,
  37: Size.XL,
  38: Size.XL,
  39: Size['1X'],
  40: Size['1X'],
  41: Size['1X'],
  42: Size['1X'],
  43: Size['1X'],
  44: Size['2X'],
  45: Size['2X'],
  46: Size['2X'],
  47: Size['3X'],
  48: Size['3X'],
  49: Size['3X'],
  50: Size['3X'],
};

const bst01BraToSize: { [bra in BST01BraSize]: Size } = {
  '30A': Size.XS,
  '30B': Size.XS,
  '30C': Size.XS,
  '30D': Size.XS,
  '30DD/E': Size.S,
  '30DDD/F': Size.S,
  '30G': Size.M,

  '32A': Size.XS,
  '32B': Size.XS,
  '32C': Size.S,
  '32D': Size.S,
  '32DD/E': Size.S,
  '32DDD/F': Size.M,
  '32G': Size.L,

  '34A': Size.XS,
  '34B': Size.S,
  '34C': Size.S,
  '34D': Size.M,
  '34DD/E': Size.M,
  '34DDD/F': Size.L,
  '34G': Size.L,

  '36A': Size.M,
  '36B': Size.M,
  '36C': Size.L,
  '36D': Size.L,
  '36DD/E': Size['XL'],
  '36DDD/F': Size['XL'],
  '36G': Size['1X'],

  '38A': Size.L,
  '38B': Size.L,
  '38C': Size['XL'],
  '38D': Size['XL'],
  '38DD/E': Size['1X'],
  '38DDD/F': Size['1X'],
  '38G': Size['2X'],

  '40A': Size.L,
  '40B': Size.XL,
  '40C': Size['1X'],
  '40D': Size['1X'],
  '40DD/E': Size['1X'],
  '40DDD/F': Size['2X'],
  '40G': Size['3X'],

  '42A': Size.XL,
  '42B': Size['1X'],
  '42C': Size['1X'],
  '42D': Size['2X'],
  '42DD/E': Size['2X'],
  '42DDD/F': Size['2X'],
  '42G': Size['3X'],

  '44A': Size['1X'],
  '44B': Size['2X'],
  '44C': Size['2X'],
  '44D': Size['2X'],
  '44DD/E': Size['3X'],
  '44DDD/F': Size['3X'],

  '46A': Size['2X'],
  '46B': Size['3X'],
  '46C': Size['3X'],
  '46D': Size['3X'],
  '46DD/E': Size['3X'],

  '48A': Size['3X'],
  '48B': Size['3X'],
  '48C': Size['3X'],
  '48D': Size['3X'],
  '48DD/E': Size['3X'],
};

export const bst01SizeBasedOnBra = (bra: string): Size | undefined => {
  return bst01BraToSize[bra as BST01BraSize];
};

export const calculateBST01Size = (waist: number | undefined, bra: string | undefined): Size => {
  const sizeFromWaist = waist ? bst01WaistToSize[waist as BST01WaistSize] : Size['?'];
  const sizeFromBra = bra ? bst01BraToSize[bra as BST01BraSize] : Size['?'];
  const finalSize = Math.max(sizeFromWaist, sizeFromBra);

  return finalSize;
};
